import { RouteFactory } from "@app/routePaths";
import enterPriseImpactTable from "@assets/events-awards/sia/sia-enterprise-impact.jpg";
import individualImpactTable from "@assets/events-awards/sia/sia-individual-impact.jpeg";
import { BlockTitle } from "@blocks/Blocks";
import AccordionV2 from "@components/Accordion/AccordionV2";
import Column from "@components/Grid/Column";

import SIAAccordionHeader from "./SIAAccordionHeader";

/**
 * Component to render SIA awards page
 */
const SIAAwardsPage = (): React.ReactElement => {
  return (
    <Column rootClassName="font-public-sans">
      <BlockTitle
        text="Awards"
        rootClassName="py-3 text-4xl md:text-6xl lg:text-8xl font-medium mb-8"
      />

      <AccordionV2
        testId="event-sia-individual-category-accordion"
        className="rounded-tl-lg rounded-tr-lg border border-gray-175 bg-gray-150 py-4"
        headerChildren={<SIAAccordionHeader title="Individual Category" />}
        arrowClassName="border-none h-auto w-auto -rotate-90 mr-6"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 py-4 pt-4">
          <ul className="list-outside list-disc pb-6 pl-8">
            <li>Impact Leader of the Year</li>
            <li>Impact Leader Excellence Award</li>
          </ul>

          <p>
            <strong>Eligibility</strong>
          </p>

          <p>The individual should be based in Singapore.</p>

          <p>
            Individual who comes from entities with clear enterprise purpose,
            including business enterprises, social enterprises, GLCs, charities
            and NGOs, are welcomed to participate.
          </p>

          <p>
            The individual should meet the Terms and Conditions of the
            Nomination Declaration form.
          </p>

          <p className="pb-6">
            The following framework and criteria will be used for sustainability
            impact measurement:
          </p>

          <div className="mb-6 lg:w-4/6">
            <img src={individualImpactTable} alt="sia individual impact" />
          </div>

          <p>
            <a
              className="text-[#007bad] hover:text-gray-750"
              href={`${RouteFactory.siaNominatePage}#assessment`}
            >
              <u>
                <strong>Click here</strong>
              </u>
            </a>
            for the assessment criteria
          </p>
        </div>
      </AccordionV2>

      <AccordionV2
        testId="event-sia-enterprise-category-accordion"
        className="rounded-bl-lg rounded-br-lg border border-t-0 border-gray-175 bg-gray-150 py-4"
        headerChildren={<SIAAccordionHeader title="Enterprise Category" />}
        arrowClassName="border-none h-auto w-auto -rotate-90 mr-6"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 py-4 pt-4">
          <p>SMEs</p>

          <ul className="list-outside list-disc pb-6 pl-8">
            <li>Impact Enterprise of the Year</li>
            <li>Impact Enterprise Excellence Award</li>
          </ul>

          <p>Large Enterprise</p>

          <ul className="list-outside list-disc pb-6 pl-8">
            <li>Impact Enterprise of the Year</li>
            <li>Impact Enterprise Excellence Award</li>
          </ul>

          <p>
            <strong>Definition</strong>
          </p>

          <p>
            Enterprises should be registered and based in Singapore. The Award
            categories are further subdivided into Small and Medium Enterprises
            (SMEs) and Large Enterprises.
          </p>

          <ul className="list-outside list-disc pb-6 pl-8">
            <li>
              According to Enterprise Singapore, SMEs refers to small and
              medium-sized enterprises, generally defined as an enterprise
              having an annual Group revenue of up to S$100 million, or maximum
              employment size of 200 employees.
            </li>
            <li>
              Large enterprises refer to an enterprise having an annual Group
              revenue larger than S$100 million, or employ more than 200
              employees.
            </li>
          </ul>

          <p>
            <strong>Eligibility</strong>
          </p>

          <p>The enterprise should be registered and based in Singapore.</p>

          <p>
            Entities with clear enterprise purpose, including business
            enterprises, social enterprises, GLCs, charities and NGOs, are
            welcomed to participate.
          </p>

          <p>
            The enterprise should meet the Terms and Conditions of the
            Nomination Declaration form.
          </p>

          <p className="mb-0 pb-6">
            The following framework and criteria will be used for sustainability
            impact measurement:
          </p>

          <div className="mb-6 lg:w-4/6">
            <img src={enterPriseImpactTable} alt="sia enterprise impact" />
          </div>

          <p>
            <a
              className="pr-1 text-[#007bad] hover:text-gray-750"
              href={`${RouteFactory.siaNominatePage}#assessment`}
            >
              <u>
                <strong>Click here</strong>
              </u>
            </a>
            for the assessment criteria
          </p>
        </div>
      </AccordionV2>
    </Column>
  );
};
export default SIAAwardsPage;
